import type React from 'react';

import { type AccordionProps, type AccordionSummaryProps } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';

import ArrowDown from 'assets/icons/icn _ 16px _down.svg?react';
import { useStyles } from 'components/accordion/styles';

interface TMXAccordionProps extends AccordionProps {
  accordionSummaryProps?: AccordionSummaryProps;
  accordionSummaryChildren: React.ReactElement;
  unmountOnClose?: boolean;
}

const TMXAccordion: React.FC<React.PropsWithChildren<TMXAccordionProps>> = ({
  accordionSummaryChildren,
  accordionSummaryProps,
  unmountOnClose = false,
  color = 'primary',
  children,
  ...props
}) => {
  const { classes, cx } = useStyles();
  const accordionClasses = cx(classes.accordionRoot, props.className);
  const summaryClasses = cx(classes.accordionSummary, color === 'secondary' && classes.accordionSecondary);
  return (
    <Accordion
      disableGutters
      square
      className={accordionClasses}
      elevation={0}
      slotProps={{ transition: { unmountOnExit: unmountOnClose, ...props.TransitionProps } }}
      {...props}
    >
      <AccordionSummary
        className={summaryClasses}
        expandIcon={accordionSummaryProps?.expandIcon || <ArrowDown />}
        {...accordionSummaryProps}
      >
        {accordionSummaryChildren}
      </AccordionSummary>
      {children}
    </Accordion>
  );
};

export default TMXAccordion;
